import { ReactElement, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppSelector } from 'app/hooks';
import { ROUTES } from 'app/constants';
import { getLastId } from 'app/helpers';

import TourView from './TourView';

function TourViewRoute(): ReactElement {
  const { tourId } = useParams<{ tourId: string }>();
  const navigate = useNavigate();

  const { data: allTours, loading: toursLoading } = useAppSelector(
    (state) => state.tours,
  );
  const { isAuthLoading, fetchUserLoading } = useAppSelector(
    (state) => state.authState,
  );

  const isLoading = isAuthLoading || fetchUserLoading || toursLoading;

  const tour = useMemo(
    () => allTours.find((t) => getLastId(t.full_id) === tourId),
    [allTours, tourId],
  );

  if (isLoading && !tour) {
    return (
      <div className="h-full bg-white relative flex items-center justify-center">
        <div className="text-center">
          <div className="w-10 h-10 rounded-full bg-black/10 animate-pulse mx-auto mb-3" />
          <p className="text-[13px] text-black/50 m-0">Loading tour…</p>
        </div>
      </div>
    );
  }

  if (!tour) {
    return (
      <div className="h-full bg-white relative flex flex-col items-center justify-center gap-3">
        <p className="text-[15px] font-semibold text-black/85 m-0">
          Tour not found
        </p>
        <p className="text-[13px] text-black/50 m-0">
          This tour may have been removed or you don&rsquo;t have access.
        </p>
        <button
          type="button"
          onClick={() => navigate(ROUTES.PERSONAL_DASHBOARD)}
          className="btn-chip mt-2"
        >
          Back to Tours
        </button>
      </div>
    );
  }

  return (
    <TourView tour={tour} onBack={() => navigate(ROUTES.PERSONAL_DASHBOARD)} />
  );
}

export default TourViewRoute;
